import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

//TODO sort signal events on BE, SI-5784
export const compareSignalEventsByDate = (a: SignalEventDto, b: SignalEventDto) =>
    a.eventHappenedDaysAgo >= b.eventHappenedDaysAgo ? 1 : -1;
